/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type SkillRow_company = {
    readonly id: string;
    readonly skillLevelsEnabled: boolean | null;
    readonly skillLevels: ReadonlyArray<{
        readonly id: string;
        readonly level: number | null;
        readonly " $fragmentRefs": FragmentRefs<"SkillLevelRow_skillLevel">;
    } | null> | null;
    readonly " $refType": "SkillRow_company";
};
export type SkillRow_company$data = SkillRow_company;
export type SkillRow_company$key = {
    readonly " $data"?: SkillRow_company$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"SkillRow_company">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SkillRow_company",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "skillLevelsEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SkillLevel",
      "kind": "LinkedField",
      "name": "skillLevels",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "level",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SkillLevelRow_skillLevel"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Company"
};
})();
(node as any).hash = '5b237df05b486d1fd351ffdcde3182e8';
export default node;
